import Axios from 'axios'

const BASE_URL = '/'

// Bounded because the app renders nothing until the startup handoff or refresh
// settles. Without a limit, a request that never answers leaves a blank page
// instead of an app that carries on unauthenticated.
const REQUEST_TIMEOUT = 10_000

const client = Axios.create({
  baseURL: BASE_URL,
  timeout: REQUEST_TIMEOUT,
  withCredentials: true,
})

/**
 * An Axios instance for the identity endpoints, most of which are served from
 * the site root rather than the `/api` prefix the rest of the app uses. The
 * cookies those endpoints rely on are path-scoped, so routing one through
 * the wrong prefix is not merely a 404: the browser withholds the very
 * cookie the request exists to spend.
 *
 * Deliberately bare. No bearer header, because these endpoints authenticate
 * by cookie. No CSRF header, because they do not check one. No response
 * interceptor, which is what leaves a refresh call unable to trigger the
 * refresh-on-401 handling that issued it, with no need to special-case the
 * request's own URL.
 *
 * @returns {Object} an Axios singleton instance
 *
 * @see https://axios-http.com/docs/instance
 */
export default client
